import React from 'react';
import PropTypes from 'prop-types';

import { Button } from './styles';

const PrimaryNormal = ({ title, onClick, icon, style, type, ...otherProps }) => {
  return (
    <Button type={type} onClick={onClick} style={style} {...otherProps}>
      {title}
      {icon}
    </Button>
  );
};

export default PrimaryNormal;

PrimaryNormal.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.string,
};
